import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import {useSelector} from 'react-redux';
import {
  getProductWideScannedCounts,
  getToteSpecificCounts
} from './utils/scanProgressUtils';
import CartIdLabel from './CartIdLabel';

const ScanProgress = ({windowWidth}) => {
  const nextPickItem = useSelector(state => state.scanToCart.nextPickItem);
  const toteAssignments = useSelector(
    state => state.scanToCart.toteAssignments
  );

  const currentItem = nextPickItem?.item || null;
  const currentTote = nextPickItem?.tote || null;

  const {placedInCurrentTote, totalAssignedToCurrentTote} =
    getToteSpecificCounts(currentTote);
  const {
    totalScannedAcrossAllTotes,
    totalRequiredAcrossAllTotes,
    allItemPieces
  } = getProductWideScannedCounts(currentItem, toteAssignments);

  const getChipStyle = status => {
    switch (status) {
      case 'picked':
        return styles.chipOrange;
      case 'picked_and_placed':
        return styles.chipGreen;
      case 'required':
      default:
        return styles.chipWhite;
    }
  };

  const renderChips = () => {
    return allItemPieces.map((piece, index) => (
      <View
        key={piece.id || index}
        style={[styles.chip, getChipStyle(piece.status)]}
      />
    ));
  };

  return (
    <View style={styles.container}>
      <View style={styles.statsContainer}>
        <View style={styles.leftSection}>
          <Text style={[styles.count, windowWidth <= 900 && styles.countMobile]}>
            {placedInCurrentTote}/{totalAssignedToCurrentTote}
          </Text>
          <Text style={[styles.label, windowWidth <= 900 && styles.labelMobile]}>
            placed in tote
          </Text>
        </View>

        <View >
          <CartIdLabel windowWidth={windowWidth} />
        </View>

        <View style={styles.rightSection}>
          <Text style={[styles.count, windowWidth <= 900 && styles.countMobile]}>
            {totalScannedAcrossAllTotes}/{totalRequiredAcrossAllTotes}
          </Text>
          <Text style={[styles.label, windowWidth <= 900 && styles.labelMobile]}>
            scanned
          </Text>
        </View>
      </View>

      <View style={styles.chipsContainer}>{renderChips()}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#000000',
    paddingHorizontal: 12,
    paddingVertical: 15
  },
  statsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 15
  },
  leftSection: {
    alignItems: 'flex-start'
  },
  rightSection: {
    alignItems: 'flex-end'
  },
  count: {
    color: '#ffffff',
    fontSize: 48,
    fontFamily: 'Poppins_600SemiBold',
    lineHeight: 50
  },
  countMobile: {
    fontSize: 32,
    lineHeight: 36
  },
  label: {
    color: '#ffffff',
    fontSize: 16,
    fontFamily: 'Poppins_300Light',
    marginTop: -5
  },
  labelMobile: {
    fontSize: 14
  },
  chipsContainer: {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    gap: 6
  },
  chip: {
    flex: 1,
    height: 24,
    borderRadius: 12
  },
  chipGray: {
    backgroundColor: '#808080'
  },
  chipWhite: {
    backgroundColor: '#ffffff'
  },
  chipOrange: {
    backgroundColor: '#ff8c00'
  },
  chipGreen: {
    backgroundColor: '#32cd32'
  }
});

export default ScanProgress;
